(function(){
  if(window.rlSave) return;
  window.rlSave = true;

  var KEY = 'rl.saved.v1';

  function read(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch(e){ return []; }
  }
  function write(list){
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
    document.dispatchEvent(new CustomEvent('rl:saved', { detail: list }));
  }
  function has(url){
    return read().some(function(i){ return i.url === url; });
  }
  function toggle(item){
    var list = read();
    var i = list.findIndex(function(x){ return x.url === item.url; });
    if(i > -1){ list.splice(i, 1); } else { list.unshift(item); }
    write(list);
    return i === -1;
  }
  function remove(url){
    write(read().filter(function(i){ return i.url !== url; }));
  }

  window.rlSaved = { read: read, has: has, toggle: toggle, remove: remove, KEY: KEY };

  /* ---------- buttons ---------- */
  function mark(btn, on){
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var lbl = btn.querySelector('[data-save-label]');
    if(lbl) lbl.textContent = on ? (btn.getAttribute('data-on') || 'Saved') : (btn.getAttribute('data-off') || 'Save');
  }

  function sync(){
    document.querySelectorAll('[data-save]').forEach(function(btn){
      mark(btn, has(btn.getAttribute('data-url')));
    });
    document.querySelectorAll('[data-save-count]').forEach(function(el){
      var n = read().length;
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('[data-save]') : null;
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var added = toggle({
      url: btn.getAttribute('data-url'),
      title: btn.getAttribute('data-title') || '',
      kicker: btn.getAttribute('data-kicker') || '',
      image: btn.getAttribute('data-image') || '',
      at: Date.now()
    });

    mark(btn, added);
    sync();

    if(added){
      btn.classList.add('is-pop');
      setTimeout(function(){ btn.classList.remove('is-pop'); }, 500);
    }
  });

  document.addEventListener('rl:saved', sync);
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', sync);
  } else { sync(); }
})();
